import { render } from "./Registered.vue?vue&type=template&id=786ffd12&scoped=true"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"

import "./Registered.vue?vue&type=style&index=0&id=786ffd12&lang=less&scoped=true"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786ffd12"]])

export default __exports__